// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.loading-container {
  margin: 0 auto;
  display: flex;
  justify-content: center;
  position: absolute;
  top: 0;
  width: 100vw;
  bottom: 0;
  align-items: center;
}

.buttonsZoom {
  transition: right 0.3s linear;
  flex-direction: column;
  display: flex;
  position: absolute;
  bottom: 40px;
  z-index: 1;
  border-radius: 0 8px 8px 0;
  cursor: pointer;
}
.buttonsZoom #zoomIn {
  box-shadow: 4px 4px 5px rgba(0, 0, 0, 0.2);
  background: #e6e7f7;
  border-radius: 8px 8px 0 0;
  border-bottom: 1px solid #9192ad;
}
.buttonsZoom #zoomOut {
  box-shadow: 4px 4px 5px rgba(0, 0, 0, 0.2);
  background: #e6e7f7;
  border-radius: 0px 0px 8px 8px;
}

.roleInfoTitle {
  padding: 32px 24px;
  width: 100%;
  background: #2f2380;
  display: flex;
  flex-shrink: 1;
  gap: 8px;
  align-items: center;
}

.boxDescription {
  background-color: #1c1359;
  padding: 24px;
  width: 100%;
  height: 100%;
}

#close-informations {
  position: absolute;
  top: 75px;
  z-index: 1001;
  width: 45px;
  height: 45px;
  border-radius: 100px;
  padding: 8px;
  transition: right 0.3s linear;
  cursor: pointer;
}

@media (min-width: 300px) and (max-width: 600px) {
  .roleInfoTitle {
    padding: 32px 0;
  }
  #close-informations {
    display: none !important;
  }
  #hide-informations {
    display: none !important;
  }
  .buttonsZoom {
    bottom: 100px;
  }
  #open-detais-mobile {
    display: block !important;
    position: absolute;
    cursor: pointer;
    bottom: 100px;
    left: 10px;
  }
}
#hide-informations {
  position: absolute;
  top: 120px;
  z-index: 1001;
  border-radius: 0 8px 8px 0;
  transition: right 0.3s linear;
  cursor: pointer;
}

#open-detais-mobile {
  display: none;
}`, "",{"version":3,"sources":["webpack://./src/components/template/base-template/roleInfo/role-info.scss"],"names":[],"mappings":"AAAA;EACI,cAAA;EACA,aAAA;EACA,uBAAA;EACA,kBAAA;EACA,MAAA;EACA,YAAA;EACA,SAAA;EACA,mBAAA;AACJ;;AAEA;EACI,6BAAA;EACA,sBAAA;EACA,aAAA;EACA,kBAAA;EACA,YAAA;EACA,UAAA;EACA,0BAAA;EACA,eAAA;AACJ;AAAI;EACI,0CAAA;EACA,mBAAA;EACA,0BAAA;EACA,gCAAA;AAER;AAAI;EACI,0CAAA;EACA,mBAAA;EACA,8BAAA;AAER;;AACA;EACI,kBAAA;EACA,WAAA;EACA,mBAAA;EACA,aAAA;EACA,cAAA;EACA,QAAA;EACA,mBAAA;AAEJ;;AAAA;EACI,yBAAA;EACA,aAAA;EACA,WAAA;EACA,YAAA;AAGJ;;AAAA;EACI,kBAAA;EAEA,SAAA;EACA,aAAA;EACA,WAAA;EACA,YAAA;EACA,oBAAA;EACA,YAAA;EACA,6BAAA;EACA,eAAA;AAEJ;;AAAA;EACI;IACI,eAAA;EAGN;EADE;IACI,wBAAA;EAGN;EADE;IACI,wBAAA;EAGN;EAAE;IACI,aAAA;EAEN;EAAE;IACI,yBAAA;IACA,kBAAA;IACA,eAAA;IACA,aAAA;IACA,UAAA;EAEN;AACF;AACA;EACI,kBAAA;EACA,UAAA;EAEA,aAAA;EAEA,0BAAA;EACA,6BAAA;EACA,eAAA;AADJ;;AAGA;EACI,aAAA;AAAJ","sourcesContent":[".loading-container {\n    margin: 0 auto;\n    display: flex;\n    justify-content: center;\n    position: absolute;\n    top: 0;\n    width: 100vw;\n    bottom: 0;\n    align-items: center;\n}\n\n.buttonsZoom {\n    transition: right 0.3s linear;\n    flex-direction: column;\n    display: flex;\n    position: absolute;\n    bottom: 40px;\n    z-index: 1;\n    border-radius: 0 8px 8px 0;\n    cursor: pointer;\n    #zoomIn {\n        box-shadow: 4px 4px 5px #00000033;\n        background: #e6e7f7;\n        border-radius: 8px 8px 0 0;\n        border-bottom: 1px solid #9192ad;\n    }\n    #zoomOut {\n        box-shadow: 4px 4px 5px #00000033;\n        background: #e6e7f7;\n        border-radius: 0px 0px 8px 8px;\n    }\n}\n.roleInfoTitle {\n    padding: 32px 24px;\n    width: 100%;\n    background: #2f2380;\n    display: flex;\n    flex-shrink: 1;\n    gap: 8px;\n    align-items: center;\n}\n.boxDescription {\n    background-color: #1c1359;\n    padding: 24px;\n    width: 100%;\n    height: 100%;\n}\n\n#close-informations {\n    position: absolute;\n\n    top: calc(45px + 30px);\n    z-index: 1001;\n    width: 45px;\n    height: 45px;\n    border-radius: 100px;\n    padding: 8px;\n    transition: right 0.3s linear;\n    cursor: pointer;\n}\n@media (min-width: 300px) and (max-width: 600px) {\n    .roleInfoTitle {\n        padding: 32px 0;\n    }\n    #close-informations {\n        display: none !important;\n    }\n    #hide-informations {\n        display: none !important;\n    }\n\n    .buttonsZoom {\n        bottom: 100px;\n    }\n    #open-detais-mobile {\n        display: block !important;\n        position: absolute;\n        cursor: pointer;\n        bottom: 100px;\n        left: 10px;\n    }\n}\n\n#hide-informations {\n    position: absolute;\n    top: calc(90px + 30px);\n\n    z-index: 1001;\n\n    border-radius: 0 8px 8px 0;\n    transition: right 0.3s linear;\n    cursor: pointer;\n}\n#open-detais-mobile {\n    display: none;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
